/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SandZNFT, SandZNFTInterface } from "../SandZNFT";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "maxSupply",
            type: "uint16",
          },
          {
            internalType: "uint32",
            name: "startTime",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "endTime",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "isPublic",
            type: "bool",
          },
          {
            internalType: "uint160",
            name: "publicPrice",
            type: "uint160",
          },
        ],
        internalType: "struct SandZNFT.StageInfo",
        name: "_initStageInfo",
        type: "tuple",
      },
      {
        internalType: "string",
        name: "_initBaseURI",
        type: "string",
      },
      {
        internalType: "uint256[4]",
        name: "_levelRewards",
        type: "uint256[4]",
      },
      {
        internalType: "address",
        name: "__recycleWallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "__signerAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sandzAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Redeemed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "bonusList",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "divisor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum SandZNFTStakeable.NFTLevel",
        name: "",
        type: "uint8",
      },
    ],
    name: "levelReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "ownerStakeInfoList",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "amount",
        type: "uint8",
      },
    ],
    name: "publicMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "recycleWallet",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_sandzAmount",
        type: "uint256",
      },
    ],
    name: "redeem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "enum SandZNFTStakeable.NFTLevel[]",
        name: "tokenLevels",
        type: "uint8[]",
      },
    ],
    name: "reserve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sandzToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[4]",
        name: "_levelRewards",
        type: "uint256[4]",
      },
    ],
    name: "setLevelReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_recycleWallet",
        type: "address",
      },
    ],
    name: "setRecycleWallet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sandzAddress",
        type: "address",
      },
    ],
    name: "setSandZToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newSigner",
        type: "address",
      },
    ],
    name: "setSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stageInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "stageId",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "maxSupply",
        type: "uint16",
      },
      {
        internalType: "uint32",
        name: "startTime",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "endTime",
        type: "uint32",
      },
      {
        internalType: "bool",
        name: "isPublic",
        type: "bool",
      },
      {
        internalType: "uint160",
        name: "publicPrice",
        type: "uint160",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16",
            name: "tokenId",
            type: "uint16",
          },
          {
            internalType: "uint8",
            name: "tokenLevel",
            type: "uint8",
          },
        ],
        internalType: "struct SandZNFTStakeable.NFTLevelSetter",
        name: "levelSetter",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenLevelList",
    outputs: [
      {
        internalType: "enum SandZNFTStakeable.NFTLevel",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "maxSupply",
            type: "uint16",
          },
          {
            internalType: "uint32",
            name: "startTime",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "endTime",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "isPublic",
            type: "bool",
          },
          {
            internalType: "uint160",
            name: "publicPrice",
            type: "uint160",
          },
        ],
        internalType: "struct SandZNFT.StageInfo",
        name: "_stageInfo",
        type: "tuple",
      },
    ],
    name: "updateStageInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelistInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "nonce",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "stageId",
        type: "uint8",
      },
      {
        internalType: "uint240",
        name: "remain",
        type: "uint240",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "redeemer",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "amount",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "nonce",
            type: "uint8",
          },
          {
            internalType: "uint72",
            name: "price",
            type: "uint72",
          },
        ],
        internalType: "struct SandZNFT.NFTVoucher",
        name: "voucher",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint8",
        name: "amount",
        type: "uint8",
      },
    ],
    name: "whitelistMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class SandZNFT__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _initStageInfo: {
      stageId: BigNumberish;
      maxSupply: BigNumberish;
      startTime: BigNumberish;
      endTime: BigNumberish;
      isPublic: boolean;
      publicPrice: BigNumberish;
    },
    _initBaseURI: string,
    _levelRewards: [BigNumberish, BigNumberish, BigNumberish, BigNumberish],
    __recycleWallet: string,
    __signerAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SandZNFT> {
    return super.deploy(
      _initStageInfo,
      _initBaseURI,
      _levelRewards,
      __recycleWallet,
      __signerAddress,
      overrides || {}
    ) as Promise<SandZNFT>;
  }
  getDeployTransaction(
    _initStageInfo: {
      stageId: BigNumberish;
      maxSupply: BigNumberish;
      startTime: BigNumberish;
      endTime: BigNumberish;
      isPublic: boolean;
      publicPrice: BigNumberish;
    },
    _initBaseURI: string,
    _levelRewards: [BigNumberish, BigNumberish, BigNumberish, BigNumberish],
    __recycleWallet: string,
    __signerAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _initStageInfo,
      _initBaseURI,
      _levelRewards,
      __recycleWallet,
      __signerAddress,
      overrides || {}
    );
  }
  attach(address: string): SandZNFT {
    return super.attach(address) as SandZNFT;
  }
  connect(signer: Signer): SandZNFT__factory {
    return super.connect(signer) as SandZNFT__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SandZNFTInterface {
    return new utils.Interface(_abi) as SandZNFTInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SandZNFT {
    return new Contract(address, _abi, signerOrProvider) as SandZNFT;
  }
}
